import { render, staticRenderFns } from "./product_list.vue?vue&type=template&id=16b15bae&scoped=true"
import script from "./product_list.vue?vue&type=script&lang=js"
export * from "./product_list.vue?vue&type=script&lang=js"
import style0 from "./product_list.vue?vue&type=style&index=0&id=16b15bae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b15bae",
  null
  
)

export default component.exports